const WikiCitySalleReceptionFormsTabsComponent = () =>
  import('@/views/wiki/communes/form/tabs/salleReception/form/WikiCitySalleReceptionFormsTabsComponent.vue')
const WikiCitySalleReceptionInformation = () =>
  import('@/views/wiki/communes/form/tabs/salleReception/form/tabs/information/WikiCitySalleReceptionInformation.vue')
const WikiCitySalleReceptionIndexPage = () =>
  import('@/views/wiki/communes/form/tabs/salleReception/index/WikiCitySalleReceptionIndexPage.vue')
const WikiPlaceItemsTab = () =>
  import('@/views/wiki/communes/form/tabs/components/WikiPlaceItemsTab.vue')
const WikiPlaceContactTab = () =>
  import('@/views/wiki/communes/form/tabs/components/WikiPlaceContactTab.vue')
const WikiPlaceTranslationTab = () =>
  import('@/views/wiki/communes/form/tabs/components/WikiPlaceTranslationTab.vue')

export const wikiCitySalleReceptionRoutes = [
  {
    path: 'salle-reception',
    children: [
      {
        path: '',
        name: 'wiki_edit_city_salle_reception_index_page_route',
        props: true,
        component: WikiCitySalleReceptionIndexPage,
        meta: {
          pre_page: '',
          next_page: ''
        }
      },
      {
        path: ':salle_reception_id',
        name: 'wiki_city_edit_salle_reception_page_route',
        component: WikiCitySalleReceptionFormsTabsComponent,
        props: true,
        children: [
          {
            path: '',
            name: 'wiki_city_edit_salle_reception_information_page_route',
            component: WikiCitySalleReceptionInformation,
            props: true
          },
          {
            path: 'translation',
            name: 'wiki_city_edit_salle_reception_translation_page_route',
            component: WikiPlaceTranslationTab,
            props: true
          },
          {
            path: 'contact',
            name: 'wiki_city_edit_salle_reception_contact_page_route',
            component: WikiPlaceContactTab,
            props: true
          },
          {
            path: 'items',
            name: 'wiki_city_edit_salle_reception_items_page_route',
            component: WikiPlaceItemsTab,
            props: true
          }
        ],
        meta: {
          type: 'edit'
        }
      },
      {
        path: 'new',
        name: 'wiki_city_create_salle_reception_page_route',
        component: WikiCitySalleReceptionFormsTabsComponent,
        props: true,
        children: [
          {
            path: '',
            name: 'wiki_city_create_salle_reception_information_page_route',
            component: WikiCitySalleReceptionInformation
          },
          {
            path: 'translation',
            name: 'wiki_city_create_salle_reception_translation_page_route',
            component: WikiPlaceTranslationTab
          },
          {
            path: 'contact',
            name: 'wiki_city_create_salle_reception_contact_page_route',
            component: WikiPlaceContactTab
          },
          {
            path: 'items',
            name: 'wiki_city_create_salle_reception_items_page_route',
            component: WikiPlaceItemsTab
          }
        ],
        meta: {
          type: 'create'
        }
      }
    ]
  }
]
